import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { useConstant } from "@hooks/useConstant";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import { daysInStage } from "../workRowCompare";
import { EMPTY_CELL_VALUE } from "./emptyCellValue";

export const WorkTimeInStageCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsWorkOverviewRow,
        string | null
    >) => {
        const now = useConstant(() => new Date());

        if (row.original.rowType !== "work") {
            return EMPTY_CELL_VALUE;
        }

        const days = daysInStage(row.original, now);

        return days === null ? EMPTY_CELL_VALUE : <span>{days} d</span>;
    },
);

WorkTimeInStageCell.displayName = "WorkTimeInStageCell";
